import React, { useEffect, useEffectEvent } from 'react';
import AppHeader from '../../common/app-header/AppHeader';
import { useDocumensoRedirect } from '../../common/hooks/useDocumensoRedirect';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const DocumentsPage = () => {
  const { t } = useTranslation();
  const { redirectToDocumenso, isLoading, error } = useDocumensoRedirect();

  const startRedirect = useEffectEvent(() => {
    if (!isLoading && !error) {
      redirectToDocumenso('/documents');
    }
  });

  // Kick off the redirect once on mount.
  useEffect(() => {
    startRedirect();
  }, []);

  return (
    <>
      <AppHeader title={t('headers.signingPageHeader')} />
      {error && !isLoading ? (
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: '200px',
            gap: '32px',
          }}
        >
          <Typography color='error'>Error: {error}</Typography>
          <Button
            id='documentsRetryBtn'
            variant='contained'
            onClick={() => redirectToDocumenso('/documents')}
          >
            {t('buttons.retry')}
          </Button>
        </Box>
      ) : (
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
          }}
        >
          <Typography>{t('messages.redirectingToDocumenso')}</Typography>
        </Box>
      )}
    </>
  );
};

export default DocumentsPage;
